module.exports = __webpack_public_path__ + "static/media/logo2.bafcff4f.png";